import React from 'react';
import XLogo from 'assets/svg/x_logo.svg'
import GMapsLogo from 'assets/svg/gmaps_icon.svg'

const TestimonialCard = ({ thread_username, title, list_link, thread_link, type }) => {
    return (
        <div className="flex flex-col overflow-hidden shadow-xl">
            <div className="flex flex-col justify-between flex-1 p-6 bg-white lg:py-8 lg:px-7">
                <div className="flex flex-row items-center">
                    <div className='w-full'>
                        <p className="text-lg font-bold text-gray-900 font-pj">{title}</p>
                    </div>
                    {type === 'pro' &&
                        <span className="bg-green-100 text-green-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                            PRO
                        </span>
                    }
                    {type === 'free' &&
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                            FREE
                        </span>
                    }
                </div>
                <div className="flex-1 mt-4">
                    <p className="text-base leading-relaxed text-gray-900 font-pj">
                        A list of "{title}" based on a thread of @{thread_username}.
                    </p>
                </div>
                <div className='mt-8 flex flex-row justify-center items-center'>
                    <div className='flex flex-row items-center'>
                        <img src={XLogo} className='h-6 mr-2' />
                        <a href={thread_link} target='_blank' className="text-base font-bold leading-7 text-gray-900 transition-all duration-200 border-b-2 border-gray-900 hover:border-gray-600 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 hover:text-gray-600">
                            Thread
                        </a>
                    </div>
                    <i className="fas fa-arrow-right mx-4" />
                    <div className='flex flex-row items-center'>
                        <img src={GMapsLogo} className='h-8 mr-2' />
                        <a href={list_link} target='_blank' className="text-base font-bold leading-7 text-gray-900 transition-all duration-200 border-b-2 border-gray-900 hover:border-gray-600 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 hover:text-gray-600">
                            Google Maps List
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TestimonialCard;